<template>
  <div
    class="countdown"
  >
    <span class="countdown__time">{{ hours }}</span>
    <span class="countdown__colon">:</span>
    <span class="countdown__time">{{ minutes }}</span>
    <span class="countdown__colon">:</span>
    <span class="countdown__time">{{ seconds }}</span>
  </div>
</template>

<script setup>
import dayjs from 'dayjs'

const props = defineProps({
  time: {
    type: [String, Number],
    required: true
  }
})

const emit = defineEmits(['end'])

const hours = ref('00')
const minutes = ref('00')
const seconds = ref('00')
let intervalId = null

function countdown () {
  const time = dayjs(props.time)
  const now = dayjs()
  const diff = time.diff(now, 'second')
  if (diff <= 0) {
    emit('end')
    clearInterval(intervalId)
    return
  }
  const h = Math.floor(diff / (60 * 60))
  const m = Math.floor((diff % (60 * 60)) / 60)
  const s = diff % 60
  hours.value = h < 10 ? `0${h}` : `${h}`
  minutes.value = m < 10 ? `0${m}` : `${m}`
  seconds.value = s < 10 ? `0${s}` : `${s}`
}

onBeforeMount(() => {
  intervalId = setInterval(countdown, 1000)
  countdown()
})

onBeforeUnmount(() => {
  clearInterval(intervalId)
})
</script>

<style lang="less" scoped>
.countdown {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  &__time {
    position: relative;
    display: inline-block;
    padding: 2px;
    min-width: 22px;
    border-radius: 4px;
    background: linear-gradient(180deg, #343434 0%, #141414 100%);
    border: 0.5px solid #141414;
    font-family: mon-600;
    font-size: 12px;
    line-height: 16px;
    color: white;
    text-align: center;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border-radius: 4px;
      background: conic-gradient(#646464, transparent 180deg, #646464 360deg);
      padding: 1px;
      -webkit-mask:
          linear-gradient(#fff 0 100%) content-box,
          linear-gradient(#fff 0 100%);
      -webkit-mask-composite: xor;
    }
  }
  &__colon {
    font-family: mon-600;
    font-size: 12px;
    line-height: 16px;
    color: #232323;
  }
}
</style>
